import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/analytics';
import 'firebase/functions';
import { AppString } from './constant';
import { CloudFunctionName } from '../Constants/CloudFunctionName';
import { RealtimeDatabasePaths } from '../Constants/RealtimePath';

const firebaseConfig = {
  apiKey: "AIzaSyBi3_uPeYK2b7R-NvoMTfwQb6Wr71nzz5A",
  authDomain: "meta-jupiter.firebaseapp.com",
  databaseURL: "https://meta-jupiter-default-rtdb.firebaseio.com",
  projectId: "meta-jupiter",
  storageBucket: "meta-jupiter.appspot.com",
  messagingSenderId: "459721018789",
  appId: "1:459721018789:web:e69d618cdedd33200d6c4c",
  measurementId: "G-CVCZ3VPZ22"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
export const firestore = firebase.firestore();
export const database = firebase.database();
export const analytics = firebase.analytics();
export const auth = firebase.auth();
export const cloudFunction_as = firebase.app().functions("asia-south1");
// cloudFunction_as.useEmulator('localhost', 5001);

export const CallCloudFunction = (name, payload) => {
  const cfRef = cloudFunction_as.httpsCallable(name);
  return cfRef(JSON.stringify(payload))
}

export const GetDailycoToken = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await CallCloudFunction(CloudFunctionName.generateVideocallToken, payload);
      resolve(response.data.token);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  })
}

export function login(name, password) {
  auth.signInWithEmailAndPassword(name, password).then((userCred) => {
    console.log(userCred)
  })
    .catch((err) => console.log(err))
    .finally((a) => console.log(a, "finaly"))
}

export const checkUserRoleFromRDB = (userid = "") => {
  return new Promise(async (resolve, reject) => {
    try {
      let _userid = userid.replace(/[^\w\s]/gi, '')
      let _nodelink = `${RealtimeDatabasePaths.userRoles}/${_userid}`
      let nodeRef = database.ref(_nodelink);
      const node = await nodeRef.get();
      if (node.exists) {
        resolve(node.val());
      } else {
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
}

//#region dailyco functions

export const checkForDailycoAdmin = (userToken, roomId) => {
  return new Promise(async (res, rej) => {
    try {
      console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
      const videoCallDoc = await firestore
        .collection(AppString.Dailyco_Col)
        .doc(roomId)
        .get();
      let docData = videoCallDoc.data();
      if (!docData || !docData.admins.includes(userToken.uid)) {
        rej({
          code: "NoAdmin",
          messsage: "this user is not a admin",
        });
      }
      delete docData.users;
      delete docData.admins;
      delete docData.callStarted;

      res(docData);
    } catch (error) {
      rej(error);
    }
  });
};

export const checkForDailycoMember = async (userToken) => {
  const dailycoRoomDocs = await firestore
    .collection(AppString.Dailyco_Col)
    .where("members", "array-contains", userToken.uid)
    .get();
  if (dailycoRoomDocs.empty) {
    throw "No room found for user";
  }

  for (let i = 0; i < dailycoRoomDocs.docs.length; i++) {
    if (dailycoRoomDocs.docs[i].id.includes("Breakout")) {
      return dailycoRoomDocs.docs[i].id;
    }
  }

  throw "No room found for user";
};

export const getDailycoRoomDetails = (roomId) => {
  return new Promise(async (res, rej) => {
    try {
      const videoCallDoc = await firestore
        .collection(AppString.Dailyco_Col)
        .doc(roomId)
        .get();

      let data = videoCallDoc.data();
      console.log(data);
      if (!data) {
        console.log("NoVideoRoomFound");
        rej({
          code: "NoVideoRoom",
          messsage: "NoVideoRoomFound",
        });
      }
      res(data);
    } catch (error) {
      rej(error);
    }
  });
};

export const checkDailycoRoomStatus = (room) => {
  return new Promise(async (res, rej) => {
    try {
      const videoCallDoc = await firestore
        .collection(AppString.Dailyco_Col)
        .doc(room)
        .get();
      if (!videoCallDoc.exists) {
        rej({
          code: "NoVideoRoom",
          messsage: "NoVideoRoomFound",
        });
      }
      console.log(videoCallDoc.data());
      res(videoCallDoc.data().callStarted);
    } catch (error) {
      rej(error);
    }
  });
};

  //#endregion